import { TextBox, TextBoxComponentSpacing } from './TextBox';

interface PasswordBoxProps {
    id?: string;
    dataTestid?: string;
    value: string;
    name?: string;
    readOnly?: boolean;
    disabled?: boolean;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    width?: string;
    maxLength?: number;
    onChange: (value: string) => void;
    onEnterKey?: () => void;
    onValidationEvent?: (isValid: boolean) => void;
    componentSpacing?: TextBoxComponentSpacing;
    showInfoIcon?: boolean;
    infoText?: string;
}

export const PasswordBox: React.FC<PasswordBoxProps> = ({
    id,
    dataTestid,
    value,
    name,
    readOnly = false,
    disabled,
    label,
    helperText,
    required = false,
    children,
    width = 'auto',
    maxLength,
    onChange,
    onEnterKey,
    onValidationEvent,
    componentSpacing,
    showInfoIcon = false,
    infoText,
}) => {
    const validateValue = (value: string): boolean => {
        return !!value;
    };

    return (
        <TextBox
            id={id}
            dataTestid={dataTestid}
            name={name}
            value={value}
            onEnterKey={onEnterKey}
            readOnly={readOnly}
            disabled={disabled}
            onChange={onChange}
            validateValue={validateValue}
            onValidationEvent={onValidationEvent}
            validateValueMessage='Password is required'
            label={label}
            helperText={helperText}
            required={required}
            children={children}
            width={width}
            maxLength={maxLength}
            type='password'
            componentSpacing={componentSpacing}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
        />
    );
};
